module.exports = __webpack_public_path__ + "img/Blumenwiese-380@2x.73d1dafa.jpg";